export default __webpack_public_path__ + "2a22f5e57d01843dbe2760ea75428cc9.png";